import { IComponentOptions } from 'angular';
import template from './tn-field-group.html';

class TnFieldGroupController {
    // default open state
    public open = false;
    // highlight the field group title
    public hightlight = false;

    // local open state
    public _open = false;

    $onInit(): void {
        this._open = this.open;
    }
}

export const TnFieldGroupComponent: IComponentOptions = {
    controller: TnFieldGroupController,
    template,
    bindings: {
        open: '<?',
        highlight: '<?',
    },
    transclude: {
        fieldGroupHelp: '?fieldGroupHelp',
        fieldGroupTitle: '?fieldGroupTitle',
        fieldGroupFields: '?fieldGroupFields',
    },
};
